import { AlignmentApiError } from '../shared/api';
import { TOAST } from '../shared/messages';

/** Título do Sonner persistente de erro de envio (Figma 23103). */
export function submitErrorTitle(err: unknown, online: boolean): string {
  if (!(err instanceof AlignmentApiError)) return TOAST.server;
  if (err.status === 0) {
    if (!online) return TOAST.noConnection;
    return err.code === 'timeout' ? TOAST.timeout : TOAST.interrupted;
  }
  if (err.status === 503) return TOAST.maintenance;
  if (err.status === 429) return TOAST.tooManyAttempts;
  return TOAST.server;
}
